import React, { useContext, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Switch,
  useNavigate,
} from "react-router-dom";
import { Link, Outlet } from "react-router-dom";

import {
  signOut,
} from "firebase/auth";
import { auth, googleProvider, app } from "./config/firebase";

import { CourseData } from "./CourseData";
import AboutYou from "./CourseData";
import { YourFriend, YourWork } from "./CourseData";

import Course from "./Course";
import image from "../Components/assets/icon-level-1.jpg";
import { UserName } from "./SignupLogin";
import { userName } from "./SignupLogin";
import { faPersonBreastfeeding } from "@fortawesome/free-solid-svg-icons";
import Post from "./Community/Post";
import { UserContext } from "./userFile";

function Profile() {
  const navigate = useNavigate();

  const currentUser = useContext(UserContext);
  const [activeItem, setActiveItem] = useState("mycourses"); // Default active item
  const logOut = async () => {
    try {
      await signOut(auth);
    } catch (err) {
      console.log(err);
    }
    navigate("/");
    console.log(auth?.currentUser?.email);
    console.log(auth?.currentUser?.displayName);
  };

  return (
    <>
      <div className="row">
        <div className="profile-user px-5 d-flex">
          <div>
            {currentUser && (
              <div className="current-user-info">
                <img
                  src={currentUser.photoURL}
                  className="user-photo"
                  width="150"
                  alt="avatar"
                />
                <p>{currentUser.displayName}</p>
                {/* <p>{currentUser.email}</p> */}
              </div>
            )}
          </div>
          <button className="btn btn-warning mx-1" onClick={logOut}>
            <i class="fa fa-sign-out" aria-hidden="true"></i>
          </button>
        </div>

        <div className="col-xs-12 col-sm-3 col-md-2 col-lg-2 col-xlg-2 p-3">
          <nav className=""></nav>

          <ul className="list-group">
            <Link
              style={{ cursor: "pointer" }}
              // onClick={() => navigate("../mycourses/*")}
              to="../mycourses"
              className={`text-dark ${
                activeItem === "mycourses" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "mycourses" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveItem("mycourses");
                }}
              >
                My courses
              </li>
            </Link>
            <Link
              to="community"
              className={`text-dark ${
                activeItem === "community" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "community" ? "active" : ""
                }`}
                onClick={() => setActiveItem("community")}
              >
                Community
              </li>
            </Link>
            <Link
              to="mentors"
              className={`text-dark ${
                activeItem === "mentors" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "mentors" ? "active" : ""
                }`}
                onClick={() => setActiveItem("mentors")}
              >
                Mentors
              </li>
            </Link>
            <Link
              to="assessment"
              className={`text-dark ${
                activeItem === "assessment" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "assessment" ? "active" : ""
                }`}
                onClick={() => setActiveItem("assessment")}
              >
                Assessment
              </li>
            </Link>
            <Link
              to="payment"
              className={`text-dark ${
                activeItem === "payment" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "payment" ? "active" : ""
                }`}
                onClick={() => setActiveItem("payment")}
              >
                Payment
              </li>
            </Link>
            <Link
              to="account"
              className={`text-dark ${
                activeItem === "account" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "account" ? "active" : ""
                }`}
                onClick={() => setActiveItem("account")}
              >
                Account
              </li>
            </Link>

            <Link
              to="dictionary"
              className={`text-dark ${
                activeItem === "dictionary" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "dictionary" ? "active" : ""
                }`}
                onClick={() => setActiveItem("dictionary")}
              >
                Dictionary
              </li>
            </Link>
            <Link
              to="peers"
              className={`text-dark ${
                activeItem === "peers" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "peers" ? "active" : ""
                }`}
                onClick={() => setActiveItem("peers")}
              >
                Peers
              </li>
            </Link>
            <Link
              to="ai"
              className={`text-dark ${
                activeItem === "ai" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "ai" ? "active" : ""
                }`}
                onClick={() => setActiveItem("ai")}
              >
                AI
              </li>
            </Link>
            <Link
              to="help"
              className={`text-dark ${
                activeItem === "help" ? "text-white" : ""
              } list-item`}
            >
              <li
                className={`list-group-item ${
                  activeItem === "help" ? "active" : ""
                }`}
                onClick={() => setActiveItem("help")}
              >
                Help
              </li>
            </Link>

            {/* <li className="list-group-item">Dictionery</li>
            <li className="list-group-item">Peers</li>
            <li className="list-group-item">AI</li>
            <li className="list-group-item">Help</li> */}
          </ul>
        </div>

        <div className="col-xs-12 col-sm-9 col-md-10 col-lg-10 col-xlg-10">
          <Routes>
            <Route path="/*" element={<MyCourses />} />
            <Route path="community/*" element={<Community />} />
            <Route path="mentors/*" element={<Mentors />} />
            <Route path="assessment/*" element={<Assessment />} />
            <Route path="payment/*" element={<Payment />} />
            <Route path="account/*" element={<Account />} />
            <Route path="dictionary/*" element={<Dictionary />} />
            <Route path="peers/*" element={<Peers />} />
            <Route path="ai/*" element={<Ai />} />
            <Route path="help/*" element={<Help />} />
          </Routes>
        </div>
      </div>
    </>
  );
}

export default Profile;

export function MyCourses() {
  return (
    <>
      <div className="row">
        <Card />
      </div>
    </>
  );
}

const Card = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="card-container my-3 col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xlg-2">
        <div className="card shadow-sm p-3 mb-5 bg-body rounded">
          <img src={image} className="card-img-top " alt="..." />
          <div className="card-body">
            <h5 className="card-title">Level One</h5>
            <p className="card-text">
              After completing this level, you will be able to engage in basic
              English conversation.
            </p>
            <button
              className="btn btn-primary"
              onClick={() => navigate("../../course/*")}
            >
              Go to course
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

// =================== Start Community component and its descendents =================
export function Community() {
  return (
    <>
      <Post />
    </>
  );
}

import mainMentor from "./assets/Me.jpg";

function Mentors() {
  return (
    <>
      <h1 className="display-1">Mentors</h1>

      <div className="d-flex gap-2 ">
        <div className="card col-xsm-12 col-sm-12 col-md-3 col-lg-3">
          <img
            src={mainMentor}
            className="card-img-top"
            alt="A photo of Mazin Salih. The creater of this platform."
          />
          <div className="card-body">
            <h5 className="card-title">Mazin Salih</h5>
            <p className="card-text">
              Founder & CEO of this platform. He is the main teaher as well.
            </p>
            <div className=" d-flex justify-content-evenly">
              <a
                href="https://www.facebook.com/Mazin-wadareaf"
                className="text-decoration-none"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#">
                <i className="fab fa-tiktok"></i>
              </a>
              <a href="#">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="#">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div>

        {/* <div className="card col-xsm-12 col-sm-12 col-md-3 col-lg-3">
          <img
            src={mainMentor}
            className="card-img-top"
            alt="A photo of Mazin Salih. The creater of this platform."
          />
          <div className="card-body">
            <h5 className="card-title">Mazin Salih</h5>
            <p className="card-text">
              Founder & CEO of this platform. He is the main teaher as well.
            </p>
            <div className=" d-flex justify-content-evenly">
              <a
                href="https://www.facebook.com/Mazin-wadareaf"
                className="text-decoration-none"
              >
                <i className="fab fa-facebook"></i>
              </a>
              <a href="#">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#">
                <i className="fab fa-linkedin"></i>
              </a>
              <a href="#">
                <i className="fab fa-tiktok"></i>
              </a>
              <a href="#">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="#">
                <i className="fab fa-whatsapp"></i>
              </a>
            </div>
          </div>
        </div> */}

        {/* <Routes>
          <Route path="assessment/*" element={<Assessment />} />
        </Routes> */}
      </div>
    </>
  );
}

function Assessment() {
  return (
    <>
      <h1 className="display-1">Assessment</h1>
    </>
  );
}

function Payment() {
  return (
    <>
      <div className="text-center">
        {/* <h1 className="display-1">Payment</h1> */}
        <div class="card my-3 py-4 ">
          <h5 className="card-title" lang="ar" dir="rtl">
            رسوم الكورس: خمسة ألف جنيه للمستوى - المستوى شهر - إعادة المستوى بلا
            رسوم.{" "}
          </h5>
          <div className="card-header display-5">
            Account number: <span>2865022</span>
          </div>
          <div className="card-body">
            <h5 className="card-title" lang="ar" dir="rtl">
              مازن محمد أحمد الصديق صالح
            </h5>
            <p className="card-text" lang="ar" dir="rtl">
              فرع البرلمان
            </p>
            <p className="card-text" lang="ar" dir="rtl">
              أكتب إيميلك السجلت بيه في تعليق الإشعار و رسل الإشعار في الرقم دا
              وتساب:
            </p>
            <a href="phone:+249127127993" className="btn btn-success">
              0127127993
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

function Account() {
  const currentUser = useContext(UserContext);

  return (
    <>
      <h1 className="display-1">Account</h1>
      <div className="account px-5 d-flex">
        <div className="border rounded p-2">
          {currentUser && (
            <div className="current-user-info">
              <img
                src={currentUser.photoURL}
                className="account-photo rounded"
                width="150"
                alt="avatar"
              />
              <p>{currentUser.displayName}</p>
              {/* <p>{currentUser.email}</p> */}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

function Dictionary() {
  return (
    <>
      <h1 className="display-1">Dictionary</h1>
    </>
  );
}

function Peers() {
  return (
    <>
      <h1 className="display-1">Peers</h1>
    </>
  );
}

function Ai() {
  return (
    <>
      <h1 className="display-1">AI</h1>
    </>
  );
}

function Help() {
  return (
    <>
      <h1 className="display-1">Help</h1>
    </>
  );
}
